export default __webpack_public_path__ + "static/guitar-2-6c8956843ade906e0438de42b95b123a.png";